<div class="container" [formGroup]="form">
  <div class="container__street">
    <mat-form-field>
      <mat-label>Address</mat-label>
      <input
        [readonly]="readonly"
        matInput
        placeholder="Address"
        [matAutocomplete]="matAutocomplete"
        formControlName="street"
        #streetInput
      />
    </mat-form-field>
    <mat-autocomplete
      #matAutocomplete="matAutocomplete"
      [disableRipple]="true"
      (optionSelected)="streetControl.setValue(''); selectOption($event.option.value)"
    >
      <mat-option *ngIf="isLoading; else loaded">
        <mat-progress-spinner class="spinner" diameter="24" mode="indeterminate"> </mat-progress-spinner>
      </mat-option>
      <ng-template #loaded>
        <!-- Existing Properties -->
        <section *ngIf="segmentedSuggestions['existing_properties'].length > 0" class="suggestion">
          <p class="suggestion__title">
            <ng-container *ngIf="relatedToType !== 'Property'; else addressAlreadyExists">
              Select an Existing Property
            </ng-container>
            <ng-template #addressAlreadyExists>
              One or more properties with the same address already exists:
            </ng-template>
          </p>
          <ng-container *ngFor="let suggestion of segmentedSuggestions['existing_properties']">
            <mat-option
              [value]="suggestion"
              class="address-option"
              [disabled]="suggestion.id && relatedToType === 'Property'"
              [ngClass]="{ disabled: suggestion.id && relatedToType === 'Property' }"
            >
              <p class="suggestion__content ours">{{ suggestion.address_string }}</p>
            </mat-option>
          </ng-container>
        </section>

        <!-- New Properties -->
        <section *ngIf="segmentedSuggestions['new_properties'].length > 0" class="suggestion">
          <p class="suggestion__title">Select a New Property</p>
          <mat-option *ngFor="let suggestion of segmentedSuggestions['new_properties']" [value]="suggestion">
            <p class="suggestion__content">
              {{ suggestion.address_string }}
            </p>
          </mat-option>
        </section>
      </ng-template>
    </mat-autocomplete>
  </div>
  <div class="container__city-state-zip">
    <mat-form-field data-cy="deal-city-field">
      <mat-label>City</mat-label>
      <input [readonly]="readonly" matInput formControlName="city" placeholder="City" />
    </mat-form-field>
    <mat-form-field data-cy="deal-state-field">
      <mat-label>State</mat-label>
      <input [readonly]="readonly" matInput formControlName="state" placeholder="State" />
    </mat-form-field>
    <mat-form-field data-cy="deal-postal-code-field">
      <mat-label>Zip</mat-label>
      <input [readonly]="readonly" matInput formControlName="postal_code" placeholder="Postal Code" />
    </mat-form-field>
  </div>
</div>
